import { usePagesRedirect } from '@shared/hooks/use-pages-redirect.ts';

export const useDocumentViewerPagesRedirect = () => {
  return usePagesRedirect('documentViewer');
}